import { render, staticRenderFns } from "./AxListItem.vue?vue&type=template&id=729ad525&scoped=true&"
import script from "./AxListItem.vue?vue&type=script&lang=ts&"
export * from "./AxListItem.vue?vue&type=script&lang=ts&"
import style0 from "./AxListItem.vue?vue&type=style&index=0&id=729ad525&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729ad525",
  null
  
)

export default component.exports